module.exports = __webpack_public_path__ + "static/media/masungi-nav-logo.e8acc4d9.png";